// extracted by mini-css-extract-plugin
export default {"mainUiBlock":"ail4j0","tooltipContainerWrapper":"yqCv_U"};